/*会议 */
import { $http, buildHeaders } from "./index";

//#region 会议管理

//获取列表
export const meeting_page = (params) => {
  return $http.get("/admin/Meeting/index", {
    params,
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//获取详情
export const meeting_detail = (id) => {
  return $http.get(
    "/admin/Meeting/read",
    { params: { id } },
    {
      headers: buildHeaders(3, "数据加载中，请稍后……"),
    },
  );
};

//获取会议信息
export const meeting_info = (id) => {
  return $http.get(
    "/admin/Meeting/info",
    { params: { id } },
    {
      headers: buildHeaders(3, "数据加载中，请稍后……"),
    },
  );
};

//添加
export const meeting_add = (data) => {
  return $http.post("/admin/Meeting/add", data, {
    headers: buildHeaders(3, "正在提交数据，请稍后……"),
  });
};

//修改
export const meeting_edit = (data) => {
  return $http.post("/admin/Meeting/edit", data, {
    headers: buildHeaders(3, "正在提交数据，请稍后……"),
  });
};

//删除
export const meeting_delete = (id) => {
  return $http.post(
    "/admin/Meeting/del",
    { id },
    {
      headers: buildHeaders(3, "正在删除数据，请稍后……"),
    },
  );
};

//取消会议
export const meeting_cancel = (id) => {
  return $http.post(
    "/admin/Meeting/cancel",
    {
      id,
    },
    {
      headers: buildHeaders(3, "正在提交数据，请稍后……"),
    },
  );
};

//开始筹备
export const meeting_startPrepare = (id) => {
  return $http.post(
    "/admin/Meeting/startPrepare",
    {
      id,
    },
    {
      headers: buildHeaders(3, "正在提交数据，请稍后……"),
    },
  );
};

//标记进行
export const meeting_starting = (id) => {
  return $http.post(
    "/admin/Meeting/starting",
    {
      id,
    },
    {
      headers: buildHeaders(3, "正在提交数据，请稍后……"),
    },
  );
};

//标记结束
export const meeting_end = (id) => {
  return $http.post(
    "/admin/Meeting/end",
    {
      id,
    },
    {
      headers: buildHeaders(3, "正在提交数据，请稍后……"),
    },
  );
};

//#endregion

//#region 会议核算

//获取核算数据
export const meeting_accountingData = (id) => {
  return $http.get("/admin/Meeting/accountingData?id=" + id, {
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//获取核算详情
export const meeting_accountingDetail = (id) => {
  return $http.get("/admin/Meeting/accountingDetail?id=" + id, {
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//完成会议
export const meeting_complete = (id) => {
  return $http.post(
    "/admin/Meeting/complete",
    {
      id,
    },
    {
      headers: buildHeaders(3, "正在提交数据，请稍后……"),
    },
  );
};

//提交核算
export const meeting_accountingSubmit = (data) => {
  return $http.post("/admin/Meeting/accountingSubmit", data, {
    headers: buildHeaders(3, "正在提交数据，请稍后……"),
  });
};

//取消核算
export const meeting_accountingCancel = (data) => {
  return $http.post("/admin/Meeting/accountingCancel", data, {
    headers: buildHeaders(3, "正在提交数据，请稍后……"),
  });
};

//#endregion

//#region 网站管理

//#region 网站管理-会议信息

//获取会议信息
export const meeting_website_meetingInfo = (id) => {
  return $http.get("/admin/MeetingWebsite/meetingInfo?meeting_id=" + id, {
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//修改会议信息
export const meeting_website_meetingInfoSave = (data) => {
  return $http.post("/admin/MeetingWebsite/meetingInfoSave", data, {
    headers: buildHeaders(3, "正在提交数据，请稍后……"),
  });
};

//#endregion

//#region 网站管理-报名表单

//获取报名表单
export const meeting_website_form_get = (id) => {
  return $http.get("/admin/MeetingWebsiteSignupForm/info?meeting_id=" + id, {
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//保存报名表单
export const meeting_website_form_save = (data) => {
  return $http.post("/admin/MeetingWebsiteSignupForm/save", data, {
    headers: buildHeaders(3, "正在提交数据，请稍后……"),
  });
};

//#endregion

//#region 网站管理-新闻管理

//获取网站新闻列表
export const meeting_website_news_page = (params) => {
  return $http.get("/admin/MeetingWebsiteNews/index", {
    params,
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//获取详情
export const meeting_website_news_detail = (id) => {
  return $http.get(
    "/admin/MeetingWebsiteNews/read",
    { params: { id } },
    {
      headers: buildHeaders(3, "数据加载中，请稍后……"),
    },
  );
};

//添加
export const meeting_website_news_add = (data) => {
  return $http.post("/admin/MeetingWebsiteNews/add", data, {
    headers: buildHeaders(3, "正在提交数据，请稍后……"),
  });
};

//修改
export const meeting_website_news_edit = (data) => {
  return $http.post("/admin/MeetingWebsiteNews/edit", data, {
    headers: buildHeaders(3, "正在提交数据，请稍后……"),
  });
};

//修改状态
export const meeting_website_news_updateStatus = (data) => {
  return $http.post("/admin/MeetingWebsiteNews/updateStatus", data, {
    headers: buildHeaders(3, "正在提交数据，请稍后……"),
  });
};

//修改是否置顶
export const meeting_website_news_updateIsTop = (data) => {
  return $http.post("/admin/MeetingWebsiteNews/updateIsTop", data, {
    headers: buildHeaders(3, "正在提交数据，请稍后……"),
  });
};

//删除
export const meeting_website_news_delete = (id) => {
  return $http.post(
    "/admin/MeetingWebsiteNews/del",
    { id },
    {
      headers: buildHeaders(3, "正在删除数据，请稍后……"),
    },
  );
};

//#endregion

//#region 网站管理-日程配置

//获取列表
export const meeting_website_schedule_page = (params) => {
  return $http.get("/admin/MeetingWebsite/getScheduleList", {
    params,
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//获取详情
export const meeting_website_schedule_detail = (params) => {
  return $http.get("/admin/MeetingWebsite/getScheduleDetail", {
    params,
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//修改状态
export const meeting_website_schedule_updateStatus = (data) => {
  return $http.post("/admin/MeetingWebsite/updateScheduleIsSiteShow", data, {
    headers: buildHeaders(3, "正在提交数据，请稍后……"),
  });
};

//#endregion

//#region 网站管理-嘉宾配置

//获取列表
export const meeting_website_guest_page = (params) => {
  return $http.get("/admin/MeetingWebsiteGuest/index", {
    params,
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//获取详情
export const meeting_website_guest_detail = (id) => {
  return $http.get(
    "/admin/MeetingWebsiteGuest/read",
    { params: { id } },
    {
      headers: buildHeaders(3, "数据加载中，请稍后……"),
    },
  );
};

//添加
export const meeting_website_guest_addBatch = (data) => {
  return $http.post("/admin/MeetingWebsiteGuest/addBatch", data, {
    headers: buildHeaders(3, "正在提交数据，请稍后……"),
  });
};

//删除
export const meeting_website_guest_delete = (id) => {
  return $http.post(
    "/admin/MeetingWebsiteGuest/del",
    { id },
    {
      headers: buildHeaders(3, "正在删除数据，请稍后……"),
    },
  );
};

//#endregion

//#region 网站管理-关于我们

//获取网站关于我们
export const meeting_website_about_meetingInfo = (id) => {
  return $http.get("/admin/MeetingWebsiteAboutUs/info?meeting_id=" + id, {
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//保存网站关于我们
export const meeting_website_about_meetingInfoSave = (data) => {
  return $http.post("/admin/MeetingWebsiteAboutUs/save", data, {
    headers: buildHeaders(3, "正在提交数据，请稍后……"),
  });
};

//#endregion

//#endregion

//#region 会场管理

//获取会场列表
export const meeting_place_page = (params) => {
  return $http.get("/admin/MeetingPlace/index", {
    params,
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//获取详情
export const meeting_place_detail = (id) => {
  return $http.get(
    "/admin/MeetingPlace/read",
    { params: { id } },
    {
      headers: buildHeaders(3, "数据加载中，请稍后……"),
    },
  );
};

//添加
export const meeting_place_add = (data) => {
  return $http.post("/admin/MeetingPlace/add", data, {
    headers: buildHeaders(3, "正在提交数据，请稍后……"),
  });
};

//修改
export const meeting_place_edit = (data) => {
  return $http.post("/admin/MeetingPlace/edit", data, {
    headers: buildHeaders(3, "正在提交数据，请稍后……"),
  });
};

//修改状态
export const meeting_place_updateStatus = (data) => {
  return $http.post("/admin/MeetingPlace/updateStatus", data, {
    headers: buildHeaders(3, "正在提交数据，请稍后……"),
  });
};

//删除
export const meeting_place_delete = (id) => {
  return $http.post(
    "/admin/MeetingPlace/del",
    { id },
    {
      headers: buildHeaders(3, "正在删除数据，请稍后……"),
    },
  );
};

//#endregion

//#region 日程管理

//#region 日程管理-日程信息

//获取列表
export const meeting_schedule_page = (params) => {
  return $http.get("/admin/MeetingSchedule/index", {
    params,
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//获取详情
export const meeting_schedule_detail = (id) => {
  return $http.get(
    "/admin/MeetingSchedule/read",
    { params: { id } },
    {
      headers: buildHeaders(3, "数据加载中，请稍后……"),
    },
  );
};

//添加
export const meeting_schedule_add = (data) => {
  return $http.post("/admin/MeetingSchedule/add", data, {
    headers: buildHeaders(3, "正在提交数据，请稍后……"),
  });
};

//修改
export const meeting_schedule_edit = (data) => {
  return $http.post("/admin/MeetingSchedule/edit", data, {
    headers: buildHeaders(3, "正在提交数据，请稍后……"),
  });
};

//修改状态-是否需要签到
export const meeting_schedule_updateIsNeedSignin = (data) => {
  return $http.post("/admin/MeetingSchedule/updateIsNeedSignin", data, {
    headers: buildHeaders(3, "正在提交数据，请稍后……"),
  });
};

//修改状态-是否在网站显示
export const meeting_schedule_updateIsSiteShow = (data) => {
  return $http.post("/admin/MeetingSchedule/updateIsSiteShow", data, {
    headers: buildHeaders(3, "正在提交数据，请稍后……"),
  });
};

//修改状态-是否需要核验
export const meeting_schedule_updateIsNeedVerify = (data) => {
  return $http.post("/admin/MeetingSchedule/updateIsNeedVerify", data, {
    headers: buildHeaders(3, "正在提交数据，请稍后……"),
  });
};

//删除
export const meeting_schedule_delete = (id) => {
  return $http.post(
    "/admin/MeetingSchedule/del",
    { id },
    {
      headers: buildHeaders(3, "正在删除数据，请稍后……"),
    },
  );
};

//#endregion

//#region 日程管理-议程管理

//#region 日程管理-议程管理-议程信息
//获取列表
export const meeting_agenda_page = (params) => {
  return $http.get("/admin/MeetingAgenda/index", {
    params,
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//获取详情
export const meeting_agenda_detail = (id) => {
  return $http.get(
    "/admin/MeetingAgenda/read",
    { params: { id } },
    {
      headers: buildHeaders(3, "数据加载中，请稍后……"),
    },
  );
};

//添加
export const meeting_agenda_add = (data) => {
  return $http.post("/admin/MeetingAgenda/add", data, {
    headers: buildHeaders(3, "正在提交数据，请稍后……"),
  });
};

//修改
export const meeting_agenda_edit = (data) => {
  return $http.post("/admin/MeetingAgenda/edit", data, {
    headers: buildHeaders(3, "正在提交数据，请稍后……"),
  });
};

//删除
export const meeting_agenda_delete = (id) => {
  return $http.post(
    "/admin/MeetingAgenda/del",
    { id },
    {
      headers: buildHeaders(3, "正在删除数据，请稍后……"),
    },
  );
};

//#endregion

//#region 日程管理-议程管理-嘉宾配置

//获取参会人员列表
export const meeting_agenda_attendee_list = (params) => {
  return $http.get("/admin/MeetingAttendeeAgenda/meetingAttendeeList", {
    params,
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//获取分页
export const meeting_agenda_attendee_page = (params) => {
  return $http.get("/admin/MeetingAttendeeAgenda/index", {
    params,
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//添加
export const meeting_agenda_attendee_addBatch = (data) => {
  return $http.post("/admin/MeetingAttendeeAgenda/addBatch", data, {
    headers: buildHeaders(3, "正在提交数据，请稍后……"),
  });
};

//删除
export const meeting_agenda_attendee_delete = (id) => {
  return $http.post(
    "/admin/MeetingAttendeeAgenda/del",
    { id },
    {
      headers: buildHeaders(3, "正在删除数据，请稍后……"),
    },
  );
};

//#endregion

//#endregion

//#region 日程管理-人员管理

//获取参会人员列表
export const meeting_attendee_schedule_list = (params) => {
  return $http.get("/admin/MeetingAttendeeSchedule/meetingAttendeeList", {
    params,
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//获取列表
export const meeting_attendee_schedule_page = (params) => {
  return $http.get("/admin/MeetingAttendeeSchedule/index", {
    params,
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//获取详情
export const meeting_attendee_schedule_detail = (id) => {
  return $http.get(
    "/admin/MeetingAttendeeSchedule/read",
    { params: { id } },
    {
      headers: buildHeaders(3, "数据加载中，请稍后……"),
    },
  );
};

//添加
export const meeting_attendee_schedule_addBatch = (data) => {
  return $http.post("/admin/MeetingAttendeeSchedule/addBatch", data, {
    headers: buildHeaders(3, "正在提交数据，请稍后……"),
  });
};

//删除
export const meeting_attendee_schedule_delete = (id) => {
  return $http.post(
    "/admin/MeetingAttendeeSchedule/del",
    { id },
    {
      headers: buildHeaders(3, "正在删除数据，请稍后……"),
    },
  );
};

//#endregion

//#region 日程管理-坐席管理

//#endregion

//#endregion

//#region  收款计划

//获取列表
export const meeting_collected_plan_page = (params) => {
  return $http.get("/admin/MeetingCollectedPlan/index", {
    params,
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//获取详情
export const meeting_collected_plan_detail = (id) => {
  return $http.get(
    "/admin/MeetingCollectedPlan/read",
    { params: { id } },
    {
      headers: buildHeaders(3, "数据加载中，请稍后……"),
    },
  );
};

//获取详情
export const meeting_collected_plan_search = (id) => {
  return $http.get(
    "/admin/MeetingCollectedPlan/detail",
    { params: { id } },
    {
      headers: buildHeaders(3, "数据加载中，请稍后……"),
    },
  );
};

//添加
export const meeting_collected_plan_add = (data) => {
  return $http.post("/admin/MeetingCollectedPlan/add", data, {
    headers: buildHeaders(3, "正在提交数据，请稍后……"),
  });
};

//修改
export const meeting_collected_plan_edit = (data) => {
  return $http.post("/admin/MeetingCollectedPlan/edit", data, {
    headers: buildHeaders(3, "正在提交数据，请稍后……"),
  });
};

//删除
export const meeting_collected_plan_delete = (id) => {
  return $http.post(
    "/admin/MeetingCollectedPlan/del",
    { id },
    {
      headers: buildHeaders(3, "正在删除数据，请稍后……"),
    },
  );
};

//#endregion

//#region 报账管理

//获取列表
export const meeting_bill_page = (params) => {
  return $http.get("/admin/MeetingBill/index", {
    params,
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//获取详情
export const meeting_bill_detail = (id) => {
  return $http.get(
    "/admin/MeetingBill/read",
    { params: { id } },
    {
      headers: buildHeaders(3, "数据加载中，请稍后……"),
    },
  );
};

//获取会议报账明细项列表
export const meeting_bill_item_page = (params) => {
  return $http.get("/admin/MeetingBillItem/index", {
    params,
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//添加虚拟项
export const meeting_bill_item_add = (data) => {
  return $http.post("/admin/MeetingBillItem/add", data, {
    headers: buildHeaders(3, "正在提交数据，请稍后……"),
  });
};

//删除虚拟项
export const meeting_bill_item_delete = (data) => {
  return $http.post("/admin/MeetingBillItem/del", data, {
    headers: buildHeaders(3, "正在删除数据，请稍后……"),
  });
};

//保存会议报账明细项
export const meeting_bill_item_editBatch = (data) => {
  return $http.post("/admin/MeetingBillItem/editBatch", data, {
    headers: buildHeaders(3, "正在提交数据，请稍后……"),
  });
};

//获取生成会议报账记录数据
export const meeting_bill_record_getAddData = (params) => {
  return $http.get("/admin/MeetingBillRecord/getAddData", {
    params,
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//获取会议报账记录列表
export const meeting_bill_record_list = (params) => {
  return $http.get("/admin/MeetingBillRecord/index", {
    params,
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//获取会议报账记录单条信息
export const meeting_bill_record_detail = (params) => {
  return $http.get(
    "/admin/MeetingBillRecord/read",
    { params },
    {
      headers: buildHeaders(3, "数据加载中，请稍后……"),
    },
  );
};

//生成报账单
export const meeting_bill_record_add = (data) => {
  return $http.post("/admin/MeetingBillRecord/add", data, {
    headers: buildHeaders(3, "正在提交数据，请稍后……"),
  });
};

//导出报账单
export const meeting_bill_record_export = (params) => {
  return $http.get("/admin/MeetingBillRecord/exportDetail", {
    params,
    responseType: "blob",
    headers: buildHeaders(1, "正在下载文件，请稍后……"),
  });
};

//更改明细项是否参与提成计算
export const meeting_bill_record_updateIsIncludeCommission = (data) => {
  return $http.post("/admin/MeetingBillItem/updateIsIncludeCommission", data, {
    headers: buildHeaders(3, "正在提交数据，请稍后……"),
  });
};

//更改明细项是否参与税费计算
export const meeting_bill_record_updateIsIncludeTaxFee = (data) => {
  return $http.post("/admin/MeetingBillItem/updateIsIncludeTaxFee", data, {
    headers: buildHeaders(3, "正在提交数据，请稍后……"),
  });
};

//更改明细项是否在报账单显示
export const meeting_bill_record_updateIsShowBill = (data) => {
  return $http.post("/admin/MeetingBillItem/updateIsShowBill", data, {
    headers: buildHeaders(3, "正在提交数据，请稍后……"),
  });
};

//记录会议报账单打印次数
export const meeting_bill_record_recordPrint = (id) => {
  return $http.post("/admin/MeetingBillRecord/recordPrint", { id });
};

//#endregion

//#region 采购管理

//获取列表
export const meeting_purchase_page = (params) => {
  return $http.get("/admin/MeetingPurchase/index", {
    params,
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//获取详情
export const meeting_purchase_detail = (id) => {
  return $http.get(
    "/admin/MeetingPurchase/read",
    { params: { id } },
    {
      headers: buildHeaders(3, "数据加载中，请稍后……"),
    },
  );
};

//添加
export const meeting_purchase_add = (data) => {
  return $http.post("/admin/MeetingPurchase/add", data, {
    headers: buildHeaders(3, "正在提交数据，请稍后……"),
  });
};

//修改
export const meeting_purchase_edit = (data) => {
  return $http.post("/admin/MeetingPurchase/edit", data, {
    headers: buildHeaders(3, "正在提交数据，请稍后……"),
  });
};

//删除
export const meeting_purchase_delete = (id) => {
  return $http.post(
    "/admin/MeetingPurchase/del",
    { id },
    {
      headers: buildHeaders(3, "正在删除数据，请稍后……"),
    },
  );
};

//获取会议采购申请付款数据
export const meeting_purchase_applyPayment = (id) => {
  return $http.get("/admin/MeetingPurchase/applyPayment", {
    params: {
      id,
    },
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//提交申请付款
export const meeting_purchase_applyPaymentSubmit = (data) => {
  return $http.post("/admin/MeetingPurchase/applyPaymentSubmit", data, {
    headers: buildHeaders(3, "正在提交数据，请稍后……"),
  });
};

export const meeting_purchase_applyPaymentRecordList = (params) => {
  return $http.get("/admin/MeetingPurchase/applyPaymentRecordList", {
    params,
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//获取详情
export const meeting_purchase_applyPaymentRecordDetail = (id) => {
  return $http.get(
    "/admin/MeetingPurchase/applyPaymentRecordDetail",
    { params: { id } },
    {
      headers: buildHeaders(3, "数据加载中，请稍后……"),
    },
  );
};

//#endregion

//#region 发票管理

//获取列表
export const meeting_invoice_page = (params) => {
  return $http.get("/admin/MeetingInvoice/index", {
    params,
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//获取详情
export const meeting_invoice_detail = (id) => {
  return $http.get(
    "/admin/MeetingInvoice/read",
    { params: { id } },
    {
      headers: buildHeaders(3, "数据加载中，请稍后……"),
    },
  );
};

//获取详情
export const meeting_invoice_search = (id) => {
  return $http.get(
    "/admin/MeetingInvoice/detail",
    { params: { id } },
    {
      headers: buildHeaders(3, "数据加载中，请稍后……"),
    },
  );
};

//添加
export const meeting_invoice_add = (data) => {
  return $http.post("/admin/MeetingInvoice/add", data, {
    headers: buildHeaders(3, "正在提交数据，请稍后……"),
  });
};

//修改
export const meeting_invoice_edit = (data) => {
  return $http.post("/admin/MeetingInvoice/edit", data, {
    headers: buildHeaders(3, "正在提交数据，请稍后……"),
  });
};

//取消
export const meeting_invoice_cancel = (data) => {
  return $http.post("/admin/MeetingInvoice/cancel", data, {
    headers: buildHeaders(3, "正在提交数据，请稍后……"),
  });
};

//作废
export const meeting_invoice_invalid = (data) => {
  return $http.post("/admin/MeetingInvoice/invalid", data, {
    headers: buildHeaders(3, "正在提交数据，请稍后……"),
  });
};

//#endregion

//#region 参会人管理

//获取列表
export const meeting_attendee_page = (params) => {
  return $http.get("/admin/MeetingAttendee/index", {
    params,
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//获取详情
export const meeting_attendee_detail = (id) => {
  return $http.get(
    "/admin/MeetingAttendee/read",
    { params: { id } },
    {
      headers: buildHeaders(3, "数据加载中，请稍后……"),
    },
  );
};

//添加
export const meeting_attendee_add = (data) => {
  return $http.post("/admin/MeetingAttendee/add", data, {
    headers: buildHeaders(3, "正在提交数据，请稍后……"),
  });
};

//下载模板
export const meeting_attendee_download = () => {
  return $http.get("/admin/MeetingAttendee/downloadTemplate", {
    responseType: "blob",
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//导入
export const meeting_attendee_import = (data) => {
  let headers = buildHeaders(3, "正在提交数据，请稍后……");
  headers["Content-Type"] = "multipart/form-data";
  return $http.post("/admin/MeetingAttendee/import", data, {
    headers,
  });
};

//获取人员库人员列表
export const meeting_attendee_conferee_page = (params) => {
  return $http.get("/admin/MeetingAttendee/confereeList", {
    params,
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//从人员库导入
export const meeting_attendee_addByConferee = (data) => {
  return $http.post("/admin/MeetingAttendee/addByConferee", data, {
    headers: buildHeaders(3, "正在提交数据，请稍后……"),
  });
};

//修改
export const meeting_attendee_edit = (data) => {
  return $http.post("/admin/MeetingAttendee/edit", data, {
    headers: buildHeaders(3, "正在提交数据，请稍后……"),
  });
};

//删除
export const meeting_attendee_delete = (id) => {
  return $http.post(
    "/admin/MeetingAttendee/del",
    { id },
    {
      headers: buildHeaders(3, "正在删除数据，请稍后……"),
    },
  );
};

//#endregion

//#region 住宿安排

//获取列表
export const meeting_hotelArrange_page = (params) => {
  return $http.get("/admin/MeetingHotelArrange/index", {
    params,
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//获取详情
export const meeting_hotelArrange_detail = (id) => {
  return $http.get(
    "/admin/MeetingHotelArrange/read",
    { params: { id } },
    {
      headers: buildHeaders(3, "数据加载中，请稍后……"),
    },
  );
};

//获取详情
export const meeting_hotelArrange_search = (id) => {
  return $http.get(
    "/admin/MeetingHotelArrange/detail",
    { params: { id } },
    {
      headers: buildHeaders(3, "数据加载中，请稍后……"),
    },
  );
};

//添加
export const meeting_hotelArrange_add = (data) => {
  return $http.post("/admin/MeetingHotelArrange/add", data, {
    headers: buildHeaders(3, "正在提交数据，请稍后……"),
  });
};

//修改
export const meeting_hotelArrange_edit = (data) => {
  return $http.post("/admin/MeetingHotelArrange/edit", data, {
    headers: buildHeaders(3, "正在提交数据，请稍后……"),
  });
};

//删除
export const meeting_hotelArrange_delete = (id) => {
  return $http.post(
    "/admin/MeetingHotelArrange/del",
    { id },
    {
      headers: buildHeaders(3, "正在删除数据，请稍后……"),
    },
  );
};

//获取会议住宿安排房型单条信息
export const meeting_hotelArrange_room_type_detail = (id) => {
  return $http.get("/admin/MeetingHotelArrangeRoomType/read?id=" + id, {
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//获取会议住宿安排房号列表
export const meeting_hotelArrange_room_get = (params) => {
  return $http.get("/admin/MeetingHotelArrangeRoomType/roomList", {
    params,
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//下载模板
export const meeting_hotelArrange_room_download = () => {
  return $http.get("/admin/MeetingHotelArrangeRoom/downloadTemplate", {
    responseType: "blob",
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//导入
export const meeting_hotelArrange_room_import = (data) => {
  let headers = buildHeaders(3, "正在提交数据，请稍后……");
  headers["Content-Type"] = "multipart/form-data";
  return $http.post("/admin/MeetingHotelArrangeRoom/import", data, {
    headers,
  });
};

//添加会议住宿安排房号
export const meeting_hotelArrange_room_add = (data) => {
  return $http.post("/admin/MeetingHotelArrangeRoom/add", data, {
    headers: buildHeaders(3, "正在提交数据，请稍后……"),
  });
};

//删除会议住宿安排房号
export const meeting_hotelArrange_room_delete = (id) => {
  return $http.post(
    "/admin/MeetingHotelArrangeRoom/del",
    { id },
    {
      headers: buildHeaders(3, "正在提交数据，请稍后……"),
    },
  );
};

//#endregion

//#region 车辆管理

//获取列表
export const meeting_car_page = (params) => {
  return $http.get("/admin/MeetingCar/index", {
    params,
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//获取详情
export const meeting_car_detail = (id) => {
  return $http.get(
    "/admin/MeetingCar/read",
    { params: { id } },
    {
      headers: buildHeaders(3, "数据加载中，请稍后……"),
    },
  );
};

//添加
export const meeting_car_add = (data) => {
  return $http.post("/admin/MeetingCar/add", data, {
    headers: buildHeaders(3, "正在提交数据，请稍后……"),
  });
};

//修改
export const meeting_car_edit = (data) => {
  return $http.post("/admin/MeetingCar/edit", data, {
    headers: buildHeaders(3, "正在提交数据，请稍后……"),
  });
};

//取消
export const meeting_car_delete = (id) => {
  return $http.post(
    "/admin/MeetingCar/del",
    { id },
    {
      headers: buildHeaders(3, "正在提交数据，请稍后……"),
    },
  );
};

//#endregion

//#region 操作记录

//获取列表
export const meeting_log_page = (params) => {
  return $http.get("/admin/MeetingLog/index", {
    params,
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//获取详情
export const meeting_log_detail = (id) => {
  return $http.get(
    "/admin/MeetingLog/read",
    { params: { id } },
    {
      headers: buildHeaders(3, "数据加载中，请稍后……"),
    },
  );
};

//添加
export const meeting_log_add = (data) => {
  return $http.post("/admin/MeetingLog/add", data, {
    headers: buildHeaders(3, "正在提交数据，请稍后……"),
  });
};

//修改
export const meeting_log_edit = (data) => {
  return $http.post("/admin/MeetingLog/edit", data, {
    headers: buildHeaders(3, "正在提交数据，请稍后……"),
  });
};

//删除
export const meeting_log_delete = (id) => {
  return $http.post(
    "/admin/MeetingLog/del",
    { id },
    {
      headers: buildHeaders(3, "正在删除数据，请稍后……"),
    },
  );
};

//#endregion

//#region 会议设置

//#region 项目人员

//获取列表
export const meeting_service_person_page = (params) => {
  return $http.get("/admin/MeetingServicePerson/index", {
    params,
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//添加
export const meeting_service_person_add = (data) => {
  return $http.post("/admin/MeetingServicePerson/addBatch", data, {
    headers: buildHeaders(3, "正在提交数据，请稍后……"),
  });
};

//删除
export const meeting_service_person_delete = (id) => {
  return $http.post(
    "/admin/MeetingServicePerson/del",
    { id },
    {
      headers: buildHeaders(3, "正在删除数据，请稍后……"),
    },
  );
};

//#endregion

//#region 团队管理

//#endregion

//#endregion
